// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__32xSA","inputWrap":"Table_inputWrap__27wR_","col":"Table_col__1xgzi","bmiTooltip":"Table_bmiTooltip__1t8as"};